export default function replaceName(text, name) {
  if (!text) {
    return "";
  }

  const nameToken = /\[Name\]|\[name\]/g;

  const replacedText = text.replace(nameToken, name);

  return replacedText;
}
